import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(
  (theme) => ({
    body: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',

      [theme.breakpoints.down('mobile')]: {
        flexDirection: 'column-reverse',
      },
    },

    noCardRequired: {
      marginTop: theme.spacing(3),

      [theme.breakpoints.down('mobile')]: {
        display: 'none',
      },
    },
  }),
  {
    name: 'SignupForm',
  },
);
